// extracted by mini-css-extract-plugin
export default {"agencies":"agencies_agencies__yeEv8","content":"agencies_content__fhUj7"};